<div class="container">
  <br>
  <form class="search-form" [formGroup]="filterForm">
    <fieldset class="mat-mdc-card sgd-card" style="padding-top: 0;">
      <legend>&nbsp;Buscar por n&uacute;mero de flow&nbsp;</legend>
      <br>
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12">
          <mat-form-field class="full-width">
            <mat-label>N&uacute;mero Flow</mat-label>
            <input type="text" matInput autoFocus autocomplete="off" placeholder="2025-67673 o 67673"
              formControlName="numero" (keyup)="onKeyUpFlow($event)" />
            <mat-hint>Ingresar a&ntilde;o-n&uacute;mero o n&uacute;mero, ejemplo: 2025-1523 / 75896</mat-hint>
            @if(filterForm.controls.numero.hasError('pattern')){
            <mat-error>Formato inv&aacute;lido. Use 2025-67673 o 67673</mat-error>
            }
            @if((filterForm.controls.numero.value)){
            <button type="button" matSuffix mat-icon-button aria-label="Limpiar"
              (click)="filterForm.controls.numero.setValue(''); buscarFlow();">
              <mat-icon>close_small</mat-icon>
            </button>
            }
            <button type="button" matSuffix mat-icon-button aria-label="Buscar" (click)="buscarFlow()">
              <mat-icon>search</mat-icon>
            </button>
          </mat-form-field>
        </div>
      </div>
    </fieldset>
    <div class="row">
      <div class="col-lg-4 col-md-6 col-sm-6">
        <mat-form-field class="full-width">
          <mat-label>Fecha inicio</mat-label>
          <input matInput [matDatepicker]="fechaInicio" [max]="maxDate" formControlName="fechaInicio">
          <mat-hint>DD/MM/YYYY</mat-hint>
          <mat-datepicker-toggle matIconSuffix [for]="fechaInicio"></mat-datepicker-toggle>
          <mat-datepicker #fechaInicio></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-6">
        <mat-form-field class="full-width">
          <mat-label>Fecha fin</mat-label>
          <input matInput [matDatepicker]="fechaFin" [max]="maxDate" formControlName="fechaFin">
          <mat-hint>DD/MM/YYYY</mat-hint>
          <mat-datepicker-toggle matIconSuffix [for]="fechaFin"></mat-datepicker-toggle>
          <mat-datepicker #fechaFin></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="col-lg-4">
        <mat-form-field class="full-width">
          <mat-label>Tipo documento</mat-label>
          <mat-select formControlName="documentType">
            <mat-option value="-1">Todos</mat-option>
            @for (documentType of documentTypes; track $index) {
            <mat-option value={{documentType.id}}>{{documentType.descripcion}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="{{buzones && buzones.length > 0 ? 'col-lg-8' : 'col'}}">
        <mat-form-field class="full-width">
          <mat-label>Texto a buscar</mat-label>
          <input type="text" matInput autoFocus placeholder="Asunto, n&uacute;mero, referencia, etc." minlength="4"
            formControlName="searchText" (keyup)="onKeyUp($event)" />
          @if((filterForm.controls.searchText.value?.trim()?.length||0)>0){
          <button type="button" matSuffix mat-icon-button aria-label="Limpiar" (click)="onClear()">
            <mat-icon>close_small</mat-icon>
          </button>
          }
          <button type="button" matSuffix mat-icon-button aria-label="Buscar" (click)="reload()">
            <mat-icon>search</mat-icon>
          </button>
        </mat-form-field>
      </div>
      @if (buzones && buzones.length > 0) {
      <div class="col-lg-4">
        <mat-form-field class="full-width">
          <mat-label>Buz&oacute;n</mat-label>
          <mat-select formControlName="idBuzon">
            <mat-option value="-1">Todos</mat-option>
            @for (buzon of buzones; track $index) {
            <mat-option value={{buzon.id}}>{{buzon.cargo}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      }
    </div>
  </form>

  <mat-toolbar class="toolbar-action">
    <button mat-icon-button matTooltip="Reasignar" aria-label="Reasignar" (click)="reAsign()">
      <mat-icon>group</mat-icon>
    </button>
    <button mat-icon-button matTooltip="Archivar" aria-label="Archivar" (click)="archivar()">
      <mat-icon>save</mat-icon>
    </button>
    <button mat-icon-button matTooltip="Comentar" aria-label="Comentar" (click)="onAddComment()">
      <mat-icon>chat</mat-icon>
    </button>
    <button mat-icon-button matTooltip="Nueva tarea" aria-label="Nueva tarea" (click)="onAddTask()">
      <mat-icon>note_add</mat-icon>
    </button>
    <div class="sgd-spacer"></div>
    <button mat-icon-button matTooltip="Recargar" aria-label="Recargar" (click)="reload()">
      <mat-icon>refresh</mat-icon>
    </button>
  </mat-toolbar>

  <mat-table [dataSource]="dataSource" matSort matSortActive="created" matSortDisableClear matSortDirection="desc">
    <ng-container matColumnDef="select">
      <mat-header-cell *matHeaderCellDef>
        <mat-checkbox (change)="$event ? toggleAllRows() : null" [checked]="selection.hasValue() && isAllSelected()"
          [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
        </mat-checkbox>
      </mat-header-cell>
      <mat-cell mat-cell *matCellDef="let row">
        <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
          [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
        </mat-checkbox>
      </mat-cell>

    </ng-container>

    <ng-container matColumnDef="importante">
      <mat-header-cell *matHeaderCellDef class="recibido-star">&nbsp;</mat-header-cell>
      <mat-cell mat-cell *matCellDef="let element" class="recibido-star">
        <button mat-icon-button matTooltip="Importante" aria-label="Importante"
          (click)="setImportancia($event,element)">
          @if(element.importancia == 0){
          <mat-icon class="material-symbols-outlined" style="color: gray;">star</mat-icon>
          }@else {
          <mat-icon color="accent">star</mat-icon>
          }
        </button>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="movimiento">
      <mat-header-cell *matHeaderCellDef>Movimiento</mat-header-cell>
      <mat-cell mat-cell *matCellDef="let element">{{ element.idTarea }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="estados">
      <mat-header-cell *matHeaderCellDef>N&uacute;mero</mat-header-cell>
      <mat-cell mat-cell *matCellDef="let element">
        <div class="numero-container">
          <span class="numero-flow">{{ element.anio + "-" + element.numero }}</span>
        </div>
        <app-estados-documento [documento]="element"></app-estados-documento>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="de">
      <mat-header-cell *matHeaderCellDef>De</mat-header-cell>
      <mat-cell mat-cell *matCellDef="let element">
        @for (item of element.de; track $index) {
        <p>{{item.nombres}}</p>
        }
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="para">
      <mat-header-cell *matHeaderCellDef>Para</mat-header-cell>
      <mat-cell mat-cell *matCellDef="let element">
        @for (item of element.para; track $index) {
        <p>{{item.nombres}}</p>
        }
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="asunto">
      <mat-header-cell *matHeaderCellDef>Asunto</mat-header-cell>
      <mat-cell mat-cell *matCellDef="let element">{{ element.titulo }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="fecha">
      <mat-header-cell *matHeaderCellDef>Fecha</mat-header-cell>
      <mat-cell mat-cell *matCellDef="let element">
        {{ formatDate(element.fechaAsignacion) }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="numeroReferencia">
      <mat-header-cell *matHeaderCellDef>N&uacute;mero referencia</mat-header-cell>
      <mat-cell mat-cell *matCellDef="let element">{{ element.numeroReferencia }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="buzon">
      <mat-header-cell *matHeaderCellDef>Buz&oacute;n</mat-header-cell>
      <mat-cell mat-cell *matCellDef="let element">
        @if (element.idBuzon) {
        <section class="graf__tarea1-thumbnail" matTooltip="Buz&oacute;n compartido">
          <span class="material-symbols-outlined">
            markunread_mailbox
          </span>
        </section>
        }@else{
        <section class="graf__tarea1-thumbnail" matTooltip="Servidor p&uacute;blico">
          <span class="material-symbols-outlined">
            account_circle
          </span>
        </section>
        }
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="numeroDocumento">
      <mat-header-cell *matHeaderCellDef>No. Documento</mat-header-cell>
      <mat-cell mat-cell *matCellDef="let element">{{ element.numeroDocumento }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="usuarioAnterior">
      <mat-header-cell *matHeaderCellDef>Usuario anterior</mat-header-cell>
      <mat-cell mat-cell *matCellDef="let element">{{ element.usuarioAnterior}} <br> {{element.departamento}}</mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns;sticky:false"></mat-header-row>
    <mat-row (click)="clickedRow(row)" *matRowDef="let row; columns: displayedColumns;"
      [ngClass]="{'documento-no-leido': !row.leido || row.leido === 0}">
    </mat-row>
    @if(!isLoadingResults){
    <div class="mat-row no-data-found" *matNoDataRow><app-no-data-found /></div>
    }

  </mat-table>
  @if(isLoadingResults){
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }
  <mat-paginator #paginator [length]="resultsLength" pageSize="25" hidePageSize
    aria-label="P&aacute;gina selecci&oacute;n documentos en elaboraci&oacute;n">
  </mat-paginator>
</div>